<template>
  <div class="banner-swiper-wrapper">
    <div class="inner-wrapper">
      <van-swipe :autoplay="5000" lazy-render indicator-color="white">
        <van-swipe-item v-for="(item, index) in banners" @click="onBannerClick(item)" :key="index">
          <img class="swiper-item-image" :src="item.subject" alt="" />
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs, useMsgStore } from '@star/stores';
import { useRouter } from 'vue-router';
import { winOpen } from '@star/utils';
import { startsWith } from 'lodash-es';

const router = useRouter();
const msgStore = useMsgStore();

const { banners } = storeToRefs(msgStore);

// onMounted(() => {
//   msgStore.reqBanners({
//     num_per_page: 999,
//     chan_con: 8,
//     apply: 8,
//   });
// });
const onBannerClick = (item: any) => {
  const { content } = item;
  if (content) {
    if (!startsWith(content, 'http')) {
      router.push(content);
    } else {
      winOpen(content);
    }
  }
};
</script>

<style lang="less" scoped>
.banner-swiper-wrapper {
  height: 0;
  padding-bottom: 32.534%;
  position: relative;

  .inner-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .van-swipe {
    height: 100%;
  }

  .van-swipe-item {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    .swiper-item-image {
      width: 100%;
    }
  }

  :deep(.van-swipe__indicators) {
    display: flex;
    align-items: center;

    .van-swipe__indicator {
      width: 16px;
      height: 16px;
      background: rgb(0 0 0 / 50%);
      border-radius: 16px;

      &.van-swipe__indicator--active {
        width: 22px;
        height: 22px;
      }
    }
  }
}

//:deep(.dark-home-games) {
//  .dark-home-t .title-icon {
//    width: 20px;
//    margin-top: 2px;
//    &:not(.hot) {
//      filter: invert(50%) !important;
//    }
//  }
//}
</style>
